<template>
  <div class="booking-quote-review" :class="{initializing: !initialized}" >
    <header class="booking-quote-review-property">
      <div v-if="typeof data.listing.media !== 'undefined' && data.listing.media.length">
        <img :src="data.listing.media[0].urls.thumbnail_large" :alt="data.listing.media[0].name" class="cover">
      </div>
      <div>
        <h4 class="font-md wt-md mb-2">{{ data.listing.space_name }}</h4>
        <h5 class="wt-std fg-primary mb-6">
          {{ data.listing.address_label }}
        </h5>
        <p class="lh-std">
          <span class="fg-primary">Thank you!</span> Please review the quote below.
        </p>
      </div>
    </header>

    <h5 class="modal-subheading">Dates &amp; times</h5>

    <div class="content">
      <div v-for="(date, index) in data.days_and_times_formatted">
        <h3 class="fg-primary wt-bold mb-4">
          {{ date.day }}
        </h3>
        <div class="lh-std mb-2">
          <span class="wt-bold fg-mid-grey">
            {{ data.type === 'recce' ? 'Arrival time' : 'Call time' }}:
          </span>
          <span class="wt-std">
            {{ date.time }}
          </span>
        </div>
        <div class="lh-std" :class="{'mb-6': (index+1) !== data.days_and_times_formatted.length}">
          <span class="wt-bold fg-mid-grey">
            Address:
          </span>
          <span class="wt-std">
            Address is supplied after booking is completed.
          </span>
        </div>
        <hr v-if="(index+1) !== data.days_and_times_formatted.length" class="thin mb-6"/>
      </div>
    </div>

    <div v-if="data.has_cost">
      <h5 class="modal-subheading">Fees &amp; charges</h5>

      <div class="content">
        <table class="costs-table">
          <tr
              v-for="item in data.current_quote_for_user.user_line_items"
              :class="{'no-cost': !item.total}"
          >
            <td class="item">
              {{ item.label }}<span v-if="item.description"> - {{ item.description }}</span>
            </td>
            <td class="quantity">
              &nbsp;
            </td>
            <td class="cost">
              ${{ item.total_formatted }}
            </td>
          </tr>
          <tr class="subtotal">
            <td class="item" colspan="2">Total</td>
            <!-- td class="quantity">&nbsp;</td -->
            <td class="cost">
              ${{ data.current_quote_for_user.sub_total_formatted }}
            </td>
          </tr>
          <!-- <tr class="subtotal">
            <td class="item" colspan="2">GST</td>
            <td class="cost">
              ${{ data.current_quote_for_user.gst_total_formatted }}
            </td>
          </tr> -->
          <!-- <tr class="subtotal">
            <td class="item" colspan="2">Total {{ data.booking_type_label }}</td>
            <td class="cost">
              ${{ data.current_quote_for_user.total_formatted }}
            </td>
          </tr>
          <tr class="subtotal" v-if="data.current_quote_for_user.merchant_fee_total_formatted">
            <td class="item" colspan="2">Merchant Fee</td>
            <td class="cost">
              ${{ data.current_quote_for_user.merchant_fee_total_formatted }}
            </td>
          </tr> -->
          <!-- <tr class="grand-total">
            <td class="item" colspan="2">Total Payment</td>
            <td class="cost">
              ${{ data.current_quote_for_user.grand_total_formatted }}
            </td>
          </tr> -->
        </table>
        <p class="fg-dark-red wt-bold lh-loose align-center mb-6">
          Note: Overtime will be charged as per the
          <a href="/terms-and-conditions/hirer" @click.stop.prevent="showHirerTermsModal" class="fg-brand-blue">hirer
            terms &amp; conditions</a>.
        </p>
      </div>
    </div>

    <p class="lh-loose font-sm my-6" v-if="data.has_cost">
      <template v-if="data.type === 'recce'">
        100% payment required at the time of booking.
      </template>
      <template v-else>
        Bookings are charged 50% at the time of booking, with the remainder 50% charged 3 days prior to booking date.
        100% payment is charged if booking is made within 7 days of booking date.
      </template>
      Cancellation fees apply for last minute cancellations within 72 hours, however bookings can be paused and
      dates rescheduled for no fee due to unforeseen circumstances.
      Please see <a href="/terms-and-conditions/hirer" class="fg-brand-blue"
                    @click.stop.prevent="showHirerTermsModal">Hirer Terms &amp; Conditions</a>
      for cancellation.
    </p>


  </div>
</template>

<script>
import BaseModal from '../../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      loading: false,
      errors: {},
      activeSection: 'dates-and-times',
      initialized: true,
      insurance_documents: this.$store.getters['user/insuranceDocuments'],
      payment_method: null,
      agree_terms: false
    }
  },
  methods: {
    showHirerTermsModal () {
      window.open("/pdf/hirer-agreement.pdf", '_blank');
    },
  }
}
</script>
